/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'DEFINITION_OF_SUPPLIER_WHICH_INCLUDES_SERVICE_PROVIDERS_AND_RAW',
              'NEW_AND_EXISTING_SUPPLIERS_SUBCONTRACTORS_RISK_ASSESSMENT_TO_DI',
              'NEW_SUPPLIERS_SUBCONTRACTORS_INITIAL_SCREENING_BASED_ON_SOCIAL_',
              'EXISTING_SUPPLIERS_SUBCONTRACTORS_TRAINING_AND_COMMUNICATION_OF',
              'EXISTING_SUPPLIERS_SUBCONTRACTORS_MONITORING_SYSTEM_OF_SOCIAL_A',
              'REQUIRING_SUPPLIERS_TO_CONDUCT_SOCIAL_AND_LABOR_DUE_DILIGENCE_O',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_13: valueSchema,
  },
}
